import { createElement, useLayoutEffect, useRef } from 'react';
import { SearchResponseDeviceType } from '@sitecore-search/models';
import useContentBlock from './hooks/useContentBlock.js';
function addStyle(rfkId, node, css) {
    let styleNode = document.querySelector(`[data-rfk-id-style=${rfkId}]`);
    if (!styleNode) {
        styleNode = document.createElement('style');
        styleNode.setAttribute('type', 'text/css');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        styleNode.dataset.rfkIdStyle = rfkId;
        node.parentNode?.appendChild(styleNode);
    }
    styleNode.innerHTML = css;
}
const ContentBlock = () => {
    const { rfkId } = useContentBlock();
    const { widgetRef, queryResult: { data: { appearance: { css_names: cssNames = [], templates: { html: { devices: { [SearchResponseDeviceType.DESKTOP]: { content: htmlContent = null } = {} } = {} } = {}, css: { devices: { [SearchResponseDeviceType.DESKTOP]: { content: cssContent = null } = {} } = {} } = {}, } = {}, } = {}, } = {}, }, } = useContentBlock();
    const contentRef = useRef(null);
    // sets widget styles
    useLayoutEffect(() => {
        if (contentRef.current && cssContent) {
            addStyle(rfkId, contentRef.current, cssContent);
        }
    }, [rfkId, cssContent]);
    // sets widget content
    useLayoutEffect(() => {
        if (contentRef.current && htmlContent) {
            contentRef.current.innerHTML = htmlContent;
        }
    }, [htmlContent]);
    return createElement('div', { 'ref': widgetRef, 'data-rfkid': rfkId, 'className': cssNames.join(' ') }, createElement('div', { ref: contentRef }));
};
export default ContentBlock;
